module.exports = __webpack_public_path__ + "img/logo.ded91f93.svg";